















































































import { Vue, Component, Prop, Inject, Ref } from "vue-property-decorator";
import FileSign from "./FileSign.vue";
import { uid } from "@szgc/plt-core-v2";

import SelectComponent from "../components/SelectComponent/index.vue";

// import kinggrid from "../kinggrid";

import { createFileSignatureInfo, FILE_STAMP_PROPERTY_TYPE, USER_PROPERTY_TYPE } from "./config";
import { ElForm } from "element-ui/types/form";

interface PageItem {
  pageHeight: string;
  pageNum: string;
  pageWidth: string;
  pngId: string;
  signs: App.WebForm.FileSignatureInfo[];
}
interface Property {
  description: string;
  propertyName: string;
  reserved: boolean;
  propertyType: string;
}

interface UserFormItem {
  label: string;
  propertyName: string;
  readonly: boolean;
  required: boolean;
}

const PAGE_NORMAL_WIDTH = 800;
const SIGN_HTML_WIDTH = 150;

@Component({
  name: "FileAuth",
  components: { FileSign, SelectComponent }
})
export default class FileAuth extends Vue {
  private height: number = 0;

  private user = {
    value: "",
    text: "",
    propertyName: "",
    visible: false
  };

  @Ref("form")
  private elform!: ElForm;

  @Ref("fileSign")
  private fileSign!: FileSign;

  @Inject("client")
  private client!: "web" | "mobile";

  @Ref("menu")
  private menu!: HTMLDivElement;

  private page!: PageItem;

  private menuVisible: boolean = false;
  private menuItem!: Property;

  @Prop({
    required: true
  })
  config!: App.WebForm.ServiceOriginConfig;

  @Prop({
    required: true
  })
  private main!: {
    propertyName: string;
    result: { type: string; value: string; object: any };
  };

  private signature!: App.WebForm.FileSignatureInfo;

  @Prop({
    required: true
  })
  private properties!: Array<Property>;

  @Prop({
    required: true
  })
  private form!: { [prop: string]: { type: string; value: string } };

  private pageList: PageItem[] = [];

  private users: { [prop: string]: { value: string; text: string } } = {};

  onUserValidate(rule: any, value: any, callback: any, propertyName: string) {
    if (!this.users[propertyName].value) {
      callback(new Error(rule.message));
    } else {
      callback();
    }
  }

  private get rules() {
    const rules: any = {};
    this.userList.forEach((d) => {
      if (d.required) {
        rules[d.propertyName] = {
          required: true,
          message: "请选择" + d.label,
          validator: (rule: any, value: any, callback: any) => {
            return this.onUserValidate(rule, value, callback, d.propertyName);
          }
        };
      }
    });
    return rules;
  }

  private get userList(): UserFormItem[] {
    const userList: UserFormItem[] = [];
    const auths = this.config.auths;
    this.properties.forEach((d) => {
      if (d.propertyType === USER_PROPERTY_TYPE) {
        const auth = auths[d.propertyName];
        if (auth.read) {
          userList.push({
            propertyName: d.propertyName,
            label: d.description,
            readonly: !auth.write,
            required: auth.required
          });
        }
      }
    });
    return userList;
  }

  get style() {
    const style: any = {};
    if (this.client === "mobile") {
      style.minHeight = this.height + "px";
    } else {
      style.height = this.height + "px";
    }
    return style;
  }

  initPageSigns(page: PageItem) {
    for (let propertyName in this.form) {
      const property = this.form[propertyName];
      const value = property.value;
      if (property.type === FILE_STAMP_PROPERTY_TYPE && value) {
        const signs = JSON.parse(value) as App.WebForm.FileSignatureInfo[];

        signs.forEach((d) => {
          if (d.page + "" === page.pageNum + "") {
            page.signs.push(JSON.parse(JSON.stringify(d)));
          }
        });
      }
    }
  }

  initPageList() {
    if (this.main.result.object.pngs && this.main.result.object.pngs.length > 0) {
      const pageList = this.main.result.object.pngs.map((d: any) => ({
        ...d,
        signs: []
      })) as PageItem[];
      pageList.forEach((d) => this.initPageSigns(d));
      return pageList;
    }
    return [];
  }

  get signList() {
    const signList = this.properties.filter((d) => {
      if (d.propertyType !== FILE_STAMP_PROPERTY_TYPE) return false;
      const auths = this.config.auths;
      return auths[d.propertyName].write;
    });
    return signList;
  }

  /**
   * 判断签章在当前节点是否可以操作
   */
  private isOpEnable(sign: App.WebForm.FileSignatureInfo) {
    const propertyName = sign.propertyName;
    // 1、当前有权限，即write = true
    // 2、还没有进行文件签的章，即 sign.signTime = 0
    const writable = this.config.auths[propertyName].write;
    return writable && sign.signTime === 0;
  }

  private getSignPosition(sign: App.WebForm.FileSignatureInfo) {
    const style: { left: string; top: string } = { left: "", top: "" };
    const h = (sign.pageHeight * PAGE_NORMAL_WIDTH) / sign.pageWidth;
    const w = PAGE_NORMAL_WIDTH;
    style.left = w * sign.x - SIGN_HTML_WIDTH / 2 + "px";
    style.top = h * sign.y - SIGN_HTML_WIDTH / 2 + "px";
    return style;
  }

  /**
   * 删除未在后端正式签署的签章
   */
  async remove(sign: App.WebForm.FileSignatureInfo) {
    if (!this.isOpEnable(sign)) return;

    try {
      await this.$confirm("确定要删除该签章？", "提示", {
        type: "info"
      });
      console.log(sign);

      // form 更新
      const oldValue = this.form[sign.propertyName].value;
      if (!oldValue) return;

      const oldSigns = JSON.parse(oldValue) as App.WebForm.FileSignatureInfo[];
      const newSigns = oldSigns.filter((d) => d.opId !== sign.opId);

      this.$set(this.form, sign.propertyName, {
        ...this.form[sign.propertyName],
        value: JSON.stringify(newSigns)
      });

      const pageIndex = this.pageList.findIndex((d) => d.pageNum + "" === sign.page + "");
      console.log(pageIndex);
      if (pageIndex >= 0) {
        const signs = this.pageList[pageIndex].signs.filter((d) => d.opId !== sign.opId);
        this.$set(this.pageList, pageIndex, {
          ...this.pageList[pageIndex],
          signs: JSON.parse(JSON.stringify(signs))
        });
      }
    } catch (error) {
      console.log("取消删除");
    }
  }

  /**
   * 前端签章成功，处理数据
   * 1、更新form对应字段value
   * 2、向对应的page下的signs插入
   */
  private onSignOk(data: any) {
    this.signature = JSON.parse(
      JSON.stringify({
        ...this.signature,
        ...data,
        page: this.page.pageNum,
        pageWidth: this.page.pageWidth,
        pageHeight: this.page.pageHeight,
        propertyName: this.menuItem.propertyName,
        opId: uid()
      })
    );

    const oldValue = this.form[this.menuItem.propertyName].value;
    let newValue: any[];
    if (!oldValue) {
      newValue = [this.signature];
    } else {
      newValue = JSON.parse(oldValue);
      newValue.push(this.signature);
    }

    this.$set(this.form, this.menuItem.propertyName, {
      ...this.form[this.menuItem.propertyName],
      value: JSON.stringify(newValue)
    });

    const index = this.pageList.findIndex((d) => {
      return d.pageNum + "" === this.signature.page + "";
    });
    if (index >= 0) {
      this.$set(this.pageList, index, {
        ...this.pageList[index],
        signs: [...this.pageList[index].signs, JSON.parse(JSON.stringify(this.signature))]
      });
    }
  }

  onMenuClick(menu: Property) {
    this.menuItem = menu;
    this.hideMenu();
    this.fileSign.show();
  }

  getPageSize(page: { pageWidth: string; pageHeight: string }) {
    const style: any = {};
    style.width = PAGE_NORMAL_WIDTH + "px";
    style.height = (PAGE_NORMAL_WIDTH * Number(page.pageHeight)) / Number(page.pageWidth) + "px";
    return style;
  }

  validateUserValues(): Promise<boolean> {
    return new Promise((resolve) => {
      this.elform.validate((valid) => resolve(valid));
    });
  }

  getSignatureValues(): Promise<{
    valid: boolean;
    data: any;
    message: string;
  }> {
    return new Promise((resolve) => {
      const auths = this.config.auths;
      // 判断 必填签章是否已经签署
      const emptyStamps: any[] = [];
      for (let propertyName in this.form) {
        const field = this.form[propertyName];
        const property = this.properties.find((d) => d.propertyName === propertyName);

        if (
          property &&
          field.type === FILE_STAMP_PROPERTY_TYPE &&
          auths[propertyName].required &&
          !field.value
        ) {
          emptyStamps.push(property.description);
        }
      }
      if (emptyStamps.length === 0) {
        resolve({
          valid: true,
          data: this.form,
          message: ""
        });
      } else {
        resolve({
          valid: false,
          data: null,
          message: "请对" + emptyStamps.join("、") + "进行签章后再提交"
        });
      }
    });
  }

  async getFormValues() {
    if (this.userList.length > 0) {
      const uvalid = await this.validateUserValues();
      if (!uvalid) {
        return { valid: false, data: null, message: "" };
      } else {
        const result = await this.getSignatureValues();
        if (!result.valid) {
          return result;
        } else {
          const data = result.data as {
            [prop: string]: { type: string; value: string };
          };
          for (let propertyName in this.users) {
            data[propertyName].value = this.users[propertyName].value;
          }
          result.data = data;
          return result;
        }
      }
    } else {
      return await this.getSignatureValues();
    }
  }

  find(target: string, selector: Element): HTMLElement | null {
    const classes = Array.from(selector.classList);
    if (classes.indexOf(target) >= 0) {
      return selector as HTMLElement;
    } else {
      if (!selector.parentNode) {
        return null;
      } else {
        return this.find(target, selector.parentNode as any);
      }
    }
  }

  initWebLayout() {
    const $box = this.find("child-box", this.$el);
    if (!$box) return;
    const $page = $box.querySelector(".child-page") as HTMLDivElement;
    $page.style.padding = "0";
    $box.style.overflow = "hidden";
    const rect = $box.getBoundingClientRect();
    this.height = rect.height;
  }

  initMobileLayout() {
    const rect = document.body.getBoundingClientRect();
    this.height = rect.height * 0.5;
  }

  onPageItemClick(e: MouseEvent, page: PageItem) {
    const target = e.target as HTMLElement;
    const client = target.getBoundingClientRect();

    const x = e.offsetX / client.width;
    const y = e.offsetY / client.height;

    // 记录点击位置 坐标占比
    this.signature.x = x;
    this.signature.y = y;

    this.page = page;

    const rect = this.menu.getBoundingClientRect();

    this.menu.style.left = e.clientX - rect.width / 2 + "px";
    this.menu.style.top = e.clientY + "px";

    this.showMenu();
  }

  showMenu() {
    this.menuVisible = true;
  }

  hideMenu() {
    this.menuVisible = false;
  }

  async mounted() {
    // kinggrid.loadAssets();

    this.pageList = this.initPageList();
    const fields = this.config.results;
    this.userList.forEach((d) => {
      const u = fields[d.propertyName].object;
      if (!u) {
        this.users[d.propertyName] = {
          value: "",
          text: ""
        };
      } else {
        this.users[d.propertyName] = {
          value: u.userId,
          text: u.realName
        };
      }
    });

    if (this.client === "mobile") {
      this.initMobileLayout();
    } else {
      this.initWebLayout();
    }
    this.signature = createFileSignatureInfo();

    document.body.addEventListener("click", this.hideMenu, false);
  }

  private userSelectConfirm(data: { text: string; valueText: string }) {
    this.users[this.user.propertyName].value = data.valueText;
    this.users[this.user.propertyName].text = data.text;
  }

  private onUserClick(item: UserFormItem) {
    if (item.readonly) return;

    this.user.propertyName = item.propertyName;
    this.user.text = this.users[item.propertyName].text;
    this.user.value = this.users[item.propertyName].value;
    this.user.visible = true;
  }

  getUserText(item: UserFormItem) {
    if (this.users[item.propertyName]) {
      return this.users[item.propertyName].text;
    }
    return "";
  }

  destroyed() {
    document.body.removeEventListener("click", this.hideMenu);
  }
}
